import { Receipt } from "lucide-react";
import { ProveedorArrendamientoBadge } from "@/components/common/ProveedorArrendamientoBadge";

export function DeudorFactorajeBadge({ testid = "badge-deudor-factoraje" }) {
  return (
    <span data-testid={testid}
      className="inline-flex items-center gap-1 rounded-full border border-indigo-200 bg-indigo-50 px-2 py-0.5 text-[10.5px] font-semibold text-indigo-700">
      <Receipt className="h-3 w-3" /> Deudor de factoraje
    </span>
  );
}

export function NombreConDistintivo({ row }) {
  return (
    <span className="inline-flex flex-wrap items-center gap-1.5">
      <span>{row?.nombre ?? "—"}</span>
      {row?.es_deudor_factoraje === true && <DeudorFactorajeBadge testid={`badge-deudor-factoraje-${row.id}`} />}
      {row?.es_proveedor_arrendamiento === true && <ProveedorArrendamientoBadge testid={`badge-proveedor-arrendamiento-${row.id}`} />}
    </span>
  );
}
